<script>
export default {
    name: "FormCandidate",
    components: {
        AvatarImage: () => import("../../../theme/atoms/AvatarImage.vue")
    },
    props: {
        candidate: {
            type: Object,
            required: true
        }
    },
    computed: {
        candidateImage() {
            return this.candidate ? this.candidate.image?.absolute_path : null;
        },
        spaceImage() {
            if (this.candidate?.space?.image) {
                return this.candidate.space.image.absolute_path;
            }

            return null;
        },
    }
}
</script>

<template>
    <div>
        <div class="d-flex justify-content-center my-1 image position-relative" >
            <div class="position-relative">
                <avatar-image :src="candidateImage" wrapClass="border-radius-48" classes="border-radius-48" width="96" height="96"/>
                <avatar-image v-if="spaceImage" :src="spaceImage" img-display="contain" wrap-class="border-radius-20 position-absolute bottom-0 right-0" classes="border-radius-20" width="40" height="40"/>
            </div>
        </div>
        <p class="mb-0 label large fw-bolder text-primary text-center">{{ candidate.username }}</p>
        <p class="mb-0 label small text-center">{{ candidate.email }}</p>
    </div>
</template>

